import { render, staticRenderFns } from "./BaseTableSearches.vue?vue&type=template&id=4947a2e2&scoped=true"
import script from "./BaseTableSearches.vue?vue&type=script&lang=js"
export * from "./BaseTableSearches.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4947a2e2",
  null
  
)

export default component.exports